export class Search {

     /*
	 * Init the handler
	 */
    constructor() {

        // Store values
        this.secondaryNav = document.getElementById('menu-secondary-menu');
        this.searchModalBtns = this.secondaryNav.querySelectorAll('.search');
        this.searchModalCloseBtns = document.querySelectorAll('.search-modal__close');
        this.searchInputs = document.querySelectorAll('.search-modal .search-field');

        // Setup classes
        this.searchActive = 'search-modal-active';
        this.termsActive = 'search-terms-active';

        // Setup event listeners
        this.searchModalBtns.forEach(element => {
            element.addEventListener('click', this.toggleSearchModal.bind(this));
        });

        this.searchModalCloseBtns.forEach(element => {
            element.addEventListener('click', this.toggleSearchModal.bind(this));
        });

        this.searchInputs.forEach(element => {
            element.addEventListener('focus', this.openSearchTerms.bind(this));
        });

    }

    /**
	 * Toggles search modal in navigation
	 *
	 * @return    {void}
	 */
    toggleSearchModal(e) {
        e.preventDefault();
        const alreadyOpen = document.body.classList.contains(this.searchActive);
        if (!alreadyOpen) {
			document.body.classList.add(this.searchActive);
		} else {
            document.body.classList.remove(this.searchActive);
            document.body.classList.remove(this.termsActive);
        }
    }

    /**
	 * Displays popular search terms under search input on focus
	 *
	 * @return    {void}
	 */
    openSearchTerms() {
        document.body.classList.add(this.termsActive);
    }
}
